import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { usePitstopConfiguration } from "core/context/AppConfigurationContext";
import { useImpersonation } from "core/hooks/useImpersonation";
import { exitImpersonation } from "core/utils/impersonation";
import { useTranslation } from "react-i18next";

export function ImpersonationHeaderIcon() {
  const { IDS_URL } = usePitstopConfiguration();
  const { isImpersonating, impersonatorUserName } = useImpersonation();
  const { t } = useTranslation("Fixhub", {
    keyPrefix: "Next:Core:Impersonation",
  });

  if (!isImpersonating) {
    return null;
  }

  return (
    <Tooltip
      title={t(
        "exitTooltip",
        "You are impersonating this user. Click to return to your account ({{name}})",
        { name: impersonatorUserName }
      )}
    >
      <IconButton
        onClick={() => exitImpersonation(IDS_URL!)}
        sx={{ color: "warning.main" }}
      >
        <SwitchAccountIcon />
      </IconButton>
    </Tooltip>
  );
}
